module.exports = __webpack_public_path__ + "static/media/donate.615096e9.png";